import { useRecoilState, useRecoilValue } from 'recoil'
import { ContentView } from '../../../api/client'
import { openConversationContentIdState } from '../../../store/ConversationStore'
import { conversationViewEnabledState } from '../../../store/DomainStore'

type Props = {
    content: ContentView
    className?: string
}

const BADGE_CLASSES =
    'inline-flex shrink-0 items-center whitespace-nowrap text-xs font-medium text-ink-600 @sm:rounded-md @sm:bg-ink-100 @sm:px-1.5 @sm:py-0 @sm:ring-1 @sm:ring-inset @sm:ring-ink-500/20'

/**
 * Sits beside the Ad badge so a reader scanning chronologically can tell a reply
 * from a top-level comment. Keyed on `isReply` rather than the parent's username:
 * only X and Facebook give Arwen that, yet replies on every platform need flagging.
 *
 * It opens the conversation drawer, toggling like the speech-bubble action
 * button. Part of the conversation view rollout, so hidden for users without
 * the conversation_view_enabled toggle. Shares AdBadge's never-wrap,
 * narrow-card styling for the same one-line metadata row.
 */
export default function ReplyBadge({ content, className = '' }: Props) {
    const enabled = useRecoilValue(conversationViewEnabledState)
    const [openId, setOpenId] = useRecoilState(openConversationContentIdState)

    if (!content.isReply || !enabled) {
        return null
    }

    return (
        <button
            type="button"
            data-tooltip-id="tooltip-id"
            data-tooltip-content="View conversation"
            aria-label="Reply: view conversation"
            onClick={() => setOpenId(openId === content.id ? null : content.id)}
            className={`${BADGE_CLASSES} hover:text-ink-800 @sm:hover:bg-ink-200 ${className}`}
        >
            Reply
        </button>
    )
}
